import { callFunction } from "../../../global/functions/fbAll"

const sportsGenericTypes = {
  sportsGeneric: 'sportsGeneric',
}

const sportFunctionTypes = {
  updateScoresFromGoogleSheets: 'updateScoresFromGoogleSheets',
  getRealtimeResults: 'getRealtimeResults',
  ts_updateData_test: 'ts_updateData_test',
  getActiveGlsItems: 'getActiveGlsItems',
  testUpdateScoresFromPubSub: 'testUpdateScoresFromPubSub',
  getActiveGs: 'getActiveGs',
  simpleTest: 'simpleTest',
}

/**
 * 
 * @param {object} callData 
 * @returns - The `data` object {success,result, error}
 */
const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(sportsGenericTypes.sportsGeneric, callData)
  return data
}

export const fsfn_sports = (fsCall) => ({
  updateScoresFromGoogleSheets: (spreadsheetId, sheetName, currentEmail, matchStatusType, pojoOnly, showLogs, callback) => updateScoresFromGoogleSheets(fsCall, spreadsheetId, sheetName, currentEmail, matchStatusType, pojoOnly, showLogs, callback),
  getSportsDataGlsScores: (gls_score, callback) => getSportsDataGlsScores(gls_score, fsCall, callback),
  getRealtimeResults: (pathViews, sportsYear, _matchDateResultsName, callback) => getRealtimeResults(pathViews, sportsYear, _matchDateResultsName, fsCall, callback),
  getActiveGlsItems: (pathViews, callback) => getActiveGlsItems(pathViews, fsCall, callback),
  testUpdateScoresFromPubSub: (pathViews, callback) => testUpdateScoresFromPubSub(pathViews, fsCall, callback),
  getActiveGs: (spreadsheetId, sheetName, callback) => getActiveGs(spreadsheetId, sheetName, fsCall, callback),
  simpleTest: (callback) => simpleTest(fsCall, callback),
})

const simpleTest = async (fsCall, callback) => {
  try {
    const data = {}
    const callData = {
      sportFunctionType: sportFunctionTypes.simpleTest,
      ...data,
    }
    const response_data = await callFsFunction(fsCall, callData)// OK 
    const { result: m } = response_data ?? {}
    console.log('response_data', response_data)
    console.log(`MEMORY`, {
      rssMB: Math.round(m.rss / 1024 / 1024),
      heapUsedMB: Math.round(m.heapUsed / 1024 / 1024),
      heapTotalMB: Math.round(m.heapTotal / 1024 / 1024),
      externalMB: Math.round(m.external / 1024 / 1024),
    });
    if (callback) {
      callback(response_data)
    } else {
      return response_data
    }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {string} title  
 * @returns response_data {success, result, error}
 */
const updateScoresFromGoogleSheets = async (fsCall, spreadsheetId, sheetName, currentEmail, matchStatusType, pojoOnly, showLogs, callback) => {
  try {
    const callData = {
      sportFunctionType: sportFunctionTypes.updateScoresFromGoogleSheets,
      spreadsheetId,
      sheetName,
      currentEmail,
      matchStatusType,
      pojoOnly,
      showLogs
    }
    const response_data = await callFsFunction(fsCall, callData)// OK 
    if (callback) {
      callback(response_data)
    } else {
      return response_data
    }
  } catch (error) {
    console.error(error)
  }
}

const getActiveGlsItems = async (pathViews, fsCall, callback) => {
  try {
    const data = {
      pathViews,
    }
    const callData = {
      sportFunctionType: sportFunctionTypes.getActiveGlsItems,
      ...data,
    }
    const response_data = await callFsFunction(fsCall, callData)// OK 
    if (callback) {
      callback(response_data)
    } else {
      return response_data
    }
  } catch (error) {
    console.error(error)
  }
}

const getActiveGs = async (spreadsheetId, sheetName, fsCall, callback) => {
  try {
    const data = {
      spreadsheetId,
      sheetName,
      showLogs: true
    }
    const callData = {
      sportFunctionType: sportFunctionTypes.getActiveGs,
      ...data,
    }
    const response_data = await callFsFunction(fsCall, callData)// OK 
    if (callback) {
      callback(response_data)
    } else {
      return response_data
    }
  } catch (error) {
    console.error(error)
  }
}

const testUpdateScoresFromPubSub = async (pathViews, fsCall, callback) => {
  try {
    const data = {
      pathViews,
      pojoOnly: false,
      showLogs: true,
      testingOnly: false,
      returnAfterGls: false
    }
    const callData = {
      sportFunctionType: sportFunctionTypes.testUpdateScoresFromPubSub,
      ...data,
    }
    const response_data = await callFsFunction(fsCall, callData)// OK 
    if (callback) {
      callback(response_data)
    } else {
      return response_data
    }
  } catch (error) {
    console.error(error)
  }
}

const getRealtimeResults = async (pathViews, sportsYear, _matchDateResultsName, fsCall, callback) => {
  try {
    const data = {
      pathViews,
      sportsYear,
      _matchDateResultsName,
    }
    const callData = {
      sportFunctionType: sportFunctionTypes.getRealtimeResults,
      ...data,
    }
    const response_data = await callFsFunction(fsCall, callData)// OK 
    if (callback) {
      callback(response_data)
    } else {
      return response_data
    }
  } catch (error) {
    console.error(error)
  }
}

